/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AccountEnabledPatchForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { InfoPersonaliPatchForm } from '../model/models';
import { OperatoreServizioMensaCreationForm } from '../model/models';
import { OperatoreServizioMensaDTO } from '../model/models';
import { OperatoreServizioMensaListFilter } from '../model/models';
import { OperatoreServizioMensaPatchForm } from '../model/models';
import { OperatoreStatoAccessoDTO } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelOperatoreServizioMensaCompactDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AvviaResetPasswordOperatoreServizioMensaRequestParams {
    userId: string;
}

export interface ClearBruteForceLockoutOperatoreServizioMensaRequestParams {
    userId: string;
}

export interface CreateOperatoreServizioMensaRequestParams {
    operatoreServizioMensaCreationForm: OperatoreServizioMensaCreationForm;
}

export interface DeleteOperatoreServizioMensaRequestParams {
    userId: string;
}

export interface EditInfoPersonaliOperatoreServizioMensaRequestParams {
    userId: string;
    infoPersonaliPatchForm: InfoPersonaliPatchForm;
}

export interface GetOperatoreServizioMensaDetailRequestParams {
    userId: string;
}

export interface GetResetPasswordLinkOperatoreServizioMensaRequestParams {
    userId: string;
}

export interface GetStatoAccessoOperatoreServizioMensaRequestParams {
    userId: string;
}

export interface GetVerificationLinkOperatoreServizioMensaRequestParams {
    userId: string;
}

export interface ListOperatoriServizioMensaRequestParams {
    filter: OperatoreServizioMensaListFilter;
    pageable: Pageable;
}

export interface ReinviaVerificaOperatoreServizioMensaRequestParams {
    userId: string;
}

export interface SetAccountEnabledOperatoreServizioMensaRequestParams {
    userId: string;
    accountEnabledPatchForm: AccountEnabledPatchForm;
}

export interface UpdateOperatoreServizioMensaRequestParams {
    userId: string;
    operatoreServizioMensaPatchForm: OperatoreServizioMensaPatchForm;
}


export interface OperatoriServizioMensaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Invia l\&#39;email di reset password a un operatore-servizio mensa.
     * Audience: SUPERADMIN, OP_COMUNE. Solo su un account attivo; emette un token nuovo, quindi un link di reset copiato in precedenza smette di funzionare.
     * @endpoint post /api/v1/gestione/operatori-servizio-mensa/{user_id}/reset-password
* @param requestParameters
     */
    avviaResetPasswordOperatoreServizioMensa(requestParameters: AvviaResetPasswordOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Cancella il brute-force lockout Keycloak di un operatore-servizio mensa.
     * Audience: SUPERADMIN + OP_COMUNE (scope). Sblocca un operatore-servizio bloccato da Keycloak. 404 privacy se target non operatore-servizio mensa / fuori scope; 400 se senza keycloakSubjectId. Erede del legacy DELETE /api/v1/user/{id}/brute-force-lockout.
     * @endpoint delete /api/v1/gestione/operatori-servizio-mensa/{user_id}/brute-force-lockout
* @param requestParameters
     */
    clearBruteForceLockoutOperatoreServizioMensa(requestParameters: ClearBruteForceLockoutOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Crea un nuovo operatore-servizio mensa.
     * Audience: SUPERADMIN, OP_COMUNE. OP_COMUNE puo\&#39; creare solo con servizi_ids nei propri comuni gestiti. Authority derivata 1:1 dal ruolo.
     * @endpoint post /api/v1/gestione/operatori-servizio-mensa
* @param requestParameters
     */
    createOperatoreServizioMensa(requestParameters: CreateOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<OperatoreServizioMensaDTO>;

    /**
     * Cancella un operatore-servizio mensa.
     * Audience: SUPERADMIN + OP_COMUNE (scope). Rimuove le righe user_servizio + push token, l\&#39;utente da Keycloak, revoca sessioni e cancella l\&#39;utente locale. 404 privacy se target non operatore-servizio mensa / fuori scope; 409 se ha dati storici referenziati da FK RESTRICT. Erede del legacy DELETE /api/v1/user/{id}.
     * @endpoint delete /api/v1/gestione/operatori-servizio-mensa/{user_id}
* @param requestParameters
     */
    deleteOperatoreServizioMensa(requestParameters: DeleteOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Modifica nome/cognome di un operatore-servizio mensa.
     * Audience: SUPERADMIN, OP_COMUNE. Campi null &#x3D; no-op per quel campo. Almeno uno tra nome/cognome richiesto (400 info_personali_almeno_un_campo). Sync KC firstName/lastName best-effort.
     * @endpoint patch /api/v1/gestione/operatori-servizio-mensa/{user_id}/info
* @param requestParameters
     */
    editInfoPersonaliOperatoreServizioMensa(requestParameters: EditInfoPersonaliOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<OperatoreServizioMensaDTO>;

    /**
     * Detail di un operatore-servizio mensa.
     * Audience: SUPERADMIN (qualsiasi), OP_COMUNE (solo se il target ha almeno una riga user_servizio in un comune gestito dal caller). Privacy 404: target che non e\&#39; operatore-servizio mensa → not_found_user_text.
     * @endpoint get /api/v1/gestione/operatori-servizio-mensa/{user_id}
* @param requestParameters
     */
    getOperatoreServizioMensaDetail(requestParameters: GetOperatoreServizioMensaDetailRequestParams, extraHttpRequestParams?: any): Observable<OperatoreServizioMensaDTO>;

    /**
     * Genera il link di reset password per un operatore-servizio mensa.
     * Audience: SUPERADMIN, OP_COMUNE. Verbo POST per side-effect server-side.
     * @endpoint post /api/v1/gestione/operatori-servizio-mensa/{user_id}/get-reset-password-link
* @param requestParameters
     */
    getResetPasswordLinkOperatoreServizioMensa(requestParameters: GetResetPasswordLinkOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Stato di accesso di un operatore-servizio mensa letto da Keycloak.
     * Espone il blocco per tentativi di accesso falliti, che vive solo in Keycloak e non è rispecchiato da alcuna colonna locale: serve al backoffice per offrire lo sblocco solo a chi è davvero bloccato. Lettura separata dal dettaglio perché interroga Keycloak: un fermo di Keycloak dà 400 qui senza impedire il caricamento della scheda operatore. Operatore senza identità Keycloak → stato vuoto (niente da bloccare), non un errore.
     * @endpoint get /api/v1/gestione/operatori-servizio-mensa/{user_id}/stato-accesso
* @param requestParameters
     */
    getStatoAccessoOperatoreServizioMensa(requestParameters: GetStatoAccessoOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<OperatoreStatoAccessoDTO>;

    /**
     * Genera il link di verifica email per un operatore-servizio mensa.
     * Audience: SUPERADMIN, OP_COMUNE. Verbo POST per side-effect server-side.
     * @endpoint post /api/v1/gestione/operatori-servizio-mensa/{user_id}/get-verification-link
* @param requestParameters
     */
    getVerificationLinkOperatoreServizioMensa(requestParameters: GetVerificationLinkOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Lista paginata degli operatori-servizio mensa.
     * Filtri opzionali: q, ruolo, servizio_id, enabled. OP_COMUNE caller vede automaticamente solo i propri (scope su comuniGestiti). Default sort: email ASC, size 20.
     * @endpoint get /api/v1/gestione/operatori-servizio-mensa
* @param requestParameters
     */
    listOperatoriServizioMensa(requestParameters: ListOperatoriServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<PagedModelOperatoreServizioMensaCompactDTO>;

    /**
     * Reinvia l\&#39;email di attivazione a un operatore-servizio mensa.
     * Audience: SUPERADMIN, OP_COMUNE. Solo con un invito in attesa; riusa il token dell\&#39;invito, quindi un link di attivazione copiato in precedenza resta valido.
     * @endpoint post /api/v1/gestione/operatori-servizio-mensa/{user_id}/reinvia-verifica
* @param requestParameters
     */
    reinviaVerificaOperatoreServizioMensa(requestParameters: ReinviaVerificaOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Soft-delete o riattivazione di un operatore-servizio mensa.
     * Idempotente: PATCH con stesso valore di enabled non chiama KC. Su disable revoca anche le sessioni KC. NON cancella righe user_servizio.
     * @endpoint patch /api/v1/gestione/operatori-servizio-mensa/{user_id}/account-enabled
* @param requestParameters
     */
    setAccountEnabledOperatoreServizioMensa(requestParameters: SetAccountEnabledOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Modifica ruolo di un operatore-servizio mensa.
     * ruolo&#x3D;null &#x3D; no-op. Swap dell\&#39;authority + cleanup orfane delle righe user_servizio se il vecchio ruolo decade.
     * @endpoint put /api/v1/gestione/operatori-servizio-mensa/{user_id}
* @param requestParameters
     */
    updateOperatoreServizioMensa(requestParameters: UpdateOperatoreServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<OperatoreServizioMensaDTO>;

}
